import React from 'react'

const UseCustomerProfileMenu = () => {

  return {

  }
}

export default UseCustomerProfileMenu;